import { useContext } from 'react';
import { RequestedItemsContext } from '../context/RequestedItemsContext';

export function useRequestedItemsContext() {
  const context = useContext(RequestedItemsContext);
  if (context === undefined) {
    throw new Error(
      'useRequestedItemsContext must be used within a RequestedItemsProvider',
    );
  }
  return context;
}
